import { useNavigate } from "react-router-dom";

import { FillInTableConcurrentAccessChecker } from "@libs/concurrentAccess/services/fillInTableConcurrentAccessChecker";
import { checkFillInTableLock } from "@libs/concurrentAccess/utils/checkFillInTableLock";
import { useAuthorityType } from "@libs/roles/hooks/useAuthorityType";
import { useEditorRoles } from "@libs/roles/hooks/useEditorRoles";
import { FillInTableRoleChecker } from "@libs/roles/services/fillInTableRoleChecker";
import { ROUTE_PATHS } from "@routes/routePath";

interface Args {
  draftArticleId: string;
  ftEditorName: string | null;
  onAccessDenied: () => void;
  onConcurrentAccessDenied: () => void;
}

export const useMovePublicationDetailPage = ({
  draftArticleId,
  ftEditorName,
  onAccessDenied,
  onConcurrentAccessDenied,
}: Args) => {
  const navigate = useNavigate();
  const editorRoles = useEditorRoles();
  const authorityType = useAuthorityType();

  const movePublicationDetailPage = async () => {
    const pathname = ROUTE_PATHS.publicationFillInTable;
    const url = `${pathname}?id=${draftArticleId}`;

    if (pathname === ROUTE_PATHS.publicationFillInTable) {
      const roleChecker = new FillInTableRoleChecker({
        authorityType,
        editorRoles,
        classificationAi: "P999", // NOTE: role 확인을 위한 임의의 고정 Publication Topic Type으로 설정
        classificationManual: "P999", // NOTE: role 확인을 위한 임의의 고정 Publication Topic Type으로 설정
      });

      if (roleChecker.canAccess) {
        // 동시 접근 체크를 할때 get을 이용하여 체크하지 않고 post로 바로 선점하고 있음.
        const hasLock = await checkFillInTableLock({
          url: `${window.location.origin}${url}`,
          draftArticleId: draftArticleId.toString(),
          ftEditorName,
        });
        const fillInTableConcurrentAccessChecker =
          new FillInTableConcurrentAccessChecker({
            authorityType,
            ftEditorName,
            hasLock,
          });

        if (fillInTableConcurrentAccessChecker.canAccess) {
          navigate(url);
        } else {
          onConcurrentAccessDenied();
        }
      } else {
        onAccessDenied();
      }
    }
  };

  return {
    movePublicationDetailPage,
  };
};
